<template lang="pug" id="bar">
extends ./Base.pug
</template>

<script>
import BaseChart from './Base.vue';

export default {
  extends: BaseChart,
  name: 'aiqLineChart',
  methods: {
    getChartType() {
      return 'line';
    },
  },
};
</script>

<style lang="scss">
</style>
